import { cyrb53 } from "./cyrb53";

const compare = new Intl.Collator("ja").compare;
const makeObjHashReady = (object: any): [unknown, unknown][] =>
  typeof object === "object" && object !== null
    ? Object.entries(object)
        .sort(([a], [b]) => compare(a, b))
        .map(([k, v]) => [k, makeObjHashReady(v)])
    : Array.isArray(object)
      ? object.map(makeObjHashReady)
      : object;

export const computeObjectHash = (object: any) => {
  return cyrb53(JSON.stringify(makeObjHashReady(object)));
};
